import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { ReactElement } from 'react';
import { ReactComponent as DisconnectedImage } from '../../../assets/img/cool_ico/Disconnected.svg';
import { DisconnectedDetailsContainer } from '../styles';
import { Button } from '~/components/Button';

interface DisconnectedMachineInfoProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ModalDisconnectedMachineInfo({
  isOpen,
  onClose,
}: DisconnectedMachineInfoProps): ReactElement {
  const { t } = useTranslation();

  const infoText = [
    { question: t('suaInternetEstaFuncionando'), answer: t('verifiqueWiFiRedeEstaFuncionando') },
    { question: t('maquinaEstaLigada'), answer: t('olhadaSeEquipamentoEstaLigado') },
    { question: t('manutencaoMaquinaEstaEmDia'), answer: t('ceritifiqueMaquinaPassouManutencoes') },
    { question: t('disjuntorEstaLigado'), answer: t('disjuntorResponsavelEstaCorreto') },
    { question: t('maquinaEstaRecebendoEnergia'), answer: t('confirmeMaquinaEnergizada') },
  ];

  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      imageText={(
        <div style={{
          width: '152px', height: '152px', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
        >
          <DisconnectedImage />
        </div>
      )}
      additionalText={(
        <DisconnectedDetailsContainer>
          <ol>
            {infoText.map((item) => (
              <li key={item.question.toLowerCase().trim()}>
                <div>
                  <h3>{item.question}</h3>
                  <span>{item.answer}</span>
                </div>
              </li>
            ))}
          </ol>
        </DisconnectedDetailsContainer>
      )}
      fontSizeText={12}
      padding={24}
      customButton={(
        <Button variant="rc-link" onClick={onClose}>
          {t('fechar')}
        </Button>
      )}
    />
  );
}
